import { z } from 'zod/mini'

/** String that is not empty once trimmed (rejects '' and whitespace-only values). */
export const nonEmptyString = () =>
  z.string().check(z.trim(), z.minLength(1, 'must not be empty'))
